import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ContactForm from 'components/Forms/ContactForm';
import PropTypes from 'prop-types';
import React from 'react';
import useContactStyles from './assets/css/_contact';
import AnimatedSection from 'components/AnimatedSection';

export default function Contact(props) {
  const classes = useContactStyles();
  const { description, title, thanks, email } = props;

  return (
    <div id="contact" className={classes.root}>
      <Container>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
          <Grid item xs={12} sm={12} md={5} className={classes.contactLeft}>
            <div className="content-bg">
              <div className="content-inner">
                <AnimatedSection animation="fadeInLeft" delay={0}>
                  <Typography variant="h2" align="left" className={classes.sectionTitle}>
                    {title}
                  </Typography>
                </AnimatedSection>
                <AnimatedSection animation="fadeInLeft" delay={150}>
                  <Typography component="p" variant="subtitle1" align="left" className={classes.sectionDescription}>
                    {description}
                  </Typography>
                </AnimatedSection>
                <AnimatedSection animation="fadeInLeft" delay={250}>
                  <Typography component="p" variant="subtitle1" align="left" className={classes.sectionDescription}>
                    {email}
                  </Typography>
                </AnimatedSection>
                <AnimatedSection animation="fadeInLeft" delay={350}>
                  <Typography component="p" variant="subtitle1" align="left" className={classes.sectionDescription}>
                    {thanks}
                  </Typography>
                </AnimatedSection>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={7} className={classes.contactRight}>
            <AnimatedSection animation="fadeInRight" delay={200}>
              <ContactForm />
            </AnimatedSection>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

Contact.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
